import styles from './SecurityGraphBackdrop.module.css'

/**
 * Purely decorative abstract "connected security graph" motif. Low
 * contrast, non-interactive, and ignored by assistive tech.
 */
export function SecurityGraphBackdrop() {
  return (
    <svg
      className={styles.root}
      viewBox="0 0 960 540"
      preserveAspectRatio="xMidYMid slice"
      aria-hidden="true"
      focusable="false"
    >
      <g className={styles.edges} stroke="currentColor" strokeWidth="1">
        <line x1="120" y1="90" x2="300" y2="180" />
        <line x1="300" y1="180" x2="520" y2="120" />
        <line x1="300" y1="180" x2="360" y2="320" />
        <line x1="520" y1="120" x2="700" y2="200" />
        <line x1="520" y1="120" x2="620" y2="60" />
        <line x1="360" y1="320" x2="560" y2="380" />
        <line x1="360" y1="320" x2="200" y2="400" />
        <line x1="560" y1="380" x2="760" y2="340" />
        <line x1="700" y1="200" x2="840" y2="260" />
        <line x1="700" y1="200" x2="760" y2="340" />
        <line x1="840" y1="260" x2="900" y2="150" />
        <line x1="120" y1="90" x2="60" y2="220" />
        <line x1="60" y1="220" x2="200" y2="400" />
      </g>
      <g className={styles.nodes} fill="currentColor">
        {[
          [120, 90],
          [300, 180],
          [520, 120],
          [620, 60],
          [700, 200],
          [360, 320],
          [560, 380],
          [760, 340],
          [840, 260],
          [900, 150],
          [60, 220],
          [200, 400],
        ].map(([cx, cy], index) => (
          <circle key={`${cx}-${cy}`} cx={cx} cy={cy} r={index % 3 === 0 ? 4.5 : 3} />
        ))}
      </g>
    </svg>
  )
}
